import type { ConfigProviderProps, ThemeConfig } from 'antd/lib/config-provider'

import tailwind from '_/tailwind.config'

const defaultStylingTokens: ThemeConfig['token'] = {
  borderRadius: 2,
  fontSizeLG: 14,
  fontFamily: tailwind.theme.fontFamily.base.join(','),
  colorText: tailwind.theme.colors.black,
  colorPrimary: tailwind.theme.colors.lighthouse[500],
  colorBorder: tailwind.theme.colors.gray[300],
  /**
   * If following color customization conflicts with other component
   * styling, then please move these into the SelectDropdownWrapper
   * component so that the effect is localized.
   */
  // colorFillSecondary used by select dropdown tag display background
  colorFillSecondary: tailwind.theme.colors.lighthouse[100],
  colorIcon: tailwind.theme.colors.lighthouse[500],
  colorIconHover: tailwind.theme.colors.lighthouseBlue[600],
  // multi select clear icon
  colorTextQuaternary: tailwind.theme.colors.gray[500],
  colorTextTertiary: tailwind.theme.colors.gray[700]
}

export const antdLighthouseConfig: ConfigProviderProps = {
  // Ensures dropdown popup is relative to trigger element on scroll
  getPopupContainer: (triggerNode) =>
    triggerNode?.parentElement || document.body,

  theme: {
    token: {
      ...defaultStylingTokens
    }
  }
}
